import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {RoleService} from '../../../../services/role.service';
import {GpsLoadResponseHistoryService} from '../../../services/gps-load-response-history.service';
import {MatTableGeneratorComponent} from '../../../../shared/mat-table-generator/mat-table-generator.component';
import {BankTransferLoad} from '../../../../dto/bankTransferLoad';
import {MultiCrudDataSource} from '../../../../table-datasouces/multi-crud.datasource';
import {toDateString} from '../../../../providers/app-date-adapter';
import {LoadRefundHistoryService} from '../../../../load-refund-history.service';

@Component({
  selector: 'app-load-refunds-history',
  templateUrl: './load-refunds-history.component.html',
  styleUrls: ['./load-refunds-history.component.css']
})
export class LoadRefundsHistoryComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private roleService: RoleService,
    private changeDetectorRefs: ChangeDetectorRef,
    private loadRefundHistoryService: LoadRefundHistoryService,
  ) { }

  @ViewChild(MatTableGeneratorComponent, { static: true }) table: MatTableGeneratorComponent;


  dataSource = new MultiCrudDataSource( this.loadRefundHistoryService );

  columns = [
    { columnDef: 'customer', header: 'Customer', cell: ( row: BankTransferLoad ) => {
        if ( row.card == null ) {
          return '-';
        }
        if ( row.card.customer == null ) {
          return '-';
        }
        return row.card.customer.firstName + ' ' + row.card.customer.lastName;
      } },

    { columnDef: 'token', header: 'Token', cell: ( row: BankTransferLoad ) => {
        if ( row.card == null ){
          return '-';
        }
        return row.card.token;
      } },
    { columnDef: 'createDate', header: 'Created', cell: ( row: BankTransferLoad ) => `${ toDateString( row.createDate ) || '' }` },
    { columnDef: 'refundedDate', header: 'Refund Date', cell: ( row: BankTransferLoad ) => `${ toDateString(row.refundedDate) || '' }` },
    { columnDef: 'amount', header: 'Amount', cell: ( row: BankTransferLoad ) => `${ row.amount || '' }` },
    { columnDef: 'amountToLoad', header: 'Amount to load', cell: ( row: BankTransferLoad ) => `${ row.amountToLoad || '' }` },

  ];



  ngOnInit() {
    this.table.filters.str = this.route.snapshot.queryParamMap.get( 'search' );

  }


  getViewLink = (item: BankTransferLoad): string => '/loads/btl/' + item.id.toString();

  search( str: string ) {
    this.table.filters.str = str;
    this.onSearch();
  }

  onSearch( isInvalid = false ) {
    if ( !isInvalid ) {
      this.table.applyFilter();
    }
  }

  returnBack() {
    this.router.navigate(['../list'], {relativeTo: this.route});
  }

  editEnabled() {
    return false; // return this.roleService.hasRoles("admin");
  }

  currentUserIsAdmin() {
    return this.roleService.hasRoles('admin');
  }

  deleteEnabled() {
    return false; // return this.roleService.hasRoles("admin");
  }

  multiselectEnabled() {
    return false; // return this.roleService.hasRoles( "admin");
  }




}
